import React, { useEffect } from "react";
import io from "socket.io-client";
import { useDispatch, useSelector } from "react-redux";
import { updateOnlineUsers } from "../store/slices/userSlice";

function OnlineWebSocket() {
  const dispatch = useDispatch();

  // User State
  const user = useSelector((state) => state?.user?.response);
  // Socket reference
  let socket = null;

  useEffect(() => {
    if (user) {
      // Close previous socket connection if it exists
      if (socket) {
        socket.disconnect();
      }

      // Initialize new socket connection
      socket = io(process.env.REACT_APP_API_KEY);

      // Listen for "connect" event to ensure socket connection is established
      socket.on("connect", () => {
        console.log("Socket connected");

        // Join the room
        socket.emit("connection", {
          userId: null,
          isBusiness: true,
          businessId: user?.businessId,
        });
      });

      // Function to handle leaving the page
      const handleLeavePage = () => {
        if (socket) {
          socket.emit("leaveActiveUsersConnection", {
            userId: null,
            isBusiness: true,
            businessId: user?.businessId,
          });
          socket.disconnect();
        }
      };

      // Broadcasting
      socket.on("onlineUsers", (data) => {
        dispatch(updateOnlineUsers(data));
      });

      return () => {
        handleLeavePage();
      };
    }
  }, [user]);

  return <></>;
}

export default OnlineWebSocket;
